import { Building2, Check, ChevronsUpDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';
import { useAuth } from '@/features/auth/use-auth';
import { toastApiError } from '@/lib/toast';

/** Empresa ativa no topo da barra; com mais de uma, troca por aqui. */
export function OrganizationSwitcher() {
  const { organization, organizations, switchOrganization } = useAuth();
  const { isMobile } = useSidebar();
  if (!organization) return null;

  const label = (
    <>
      <Building2 aria-hidden />
      <span className="truncate font-medium">{organization.name}</span>
    </>
  );

  if (organizations.length < 2) {
    return (
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton tooltip={organization.name} className="cursor-default">
            {label}
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    );
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              tooltip={organization.name}
              aria-label={`Empresa ativa: ${organization.name}. Trocar de empresa`}
              className="border bg-background"
            >
              {label}
              <ChevronsUpDown aria-hidden className="ml-auto" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" side={isMobile ? 'bottom' : 'right'} className="w-64">
            <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
              Empresas
            </DropdownMenuLabel>
            {organizations.map((item) => (
              <DropdownMenuItem
                key={item.id}
                onSelect={() => {
                  if (item.id === organization.id) return;
                  switchOrganization(item.id).catch((error: unknown) =>
                    toastApiError(error, 'Não foi possível trocar de empresa.'),
                  );
                }}
              >
                <span className="flex-1 truncate">{item.name}</span>
                {item.id === organization.id && <Check aria-label="ativa" />}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
